import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import StoreManageService from "service/StoreManageService";

const ManageStoreDetailPage: React.FC = () => {
  const { id } = useParams();
  const storeService = StoreManageService();

  const [store, setStore] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState<string>("all");

  useEffect(() => {
    if (id) loadStoreDetail(id);
  }, [id]);

  const loadStoreDetail = async (storeId: string) => {
    try {
      setLoading(true);
      const resp = await storeService.storeDetail(storeId);
      setStore(resp.data ?? null);
    } catch (e) {
      console.error("Failed to load store detail", e);
    } finally {
      setLoading(false);
    }
  };

  const galleryGroups = store?.galleryGroup ?? [];

  const filteredPhotos = useMemo(() => {
    if (filter === "all") {
      return galleryGroups.flatMap((g: any) => g.items);
    }
    const group = galleryGroups.find((g: any) => g.id === filter);
    return group?.items ?? [];
  }, [filter, galleryGroups]);

  if (loading) {
    return (
      <div className="container bg-white rounded-top py-5 text-center">
        <div className="spinner-border text-primary" />
      </div>
    );
  }

  if (!store) return null;

  return (
    <div className="container bg-white rounded-top pb-5">
      <h5 className="fw-bold mt-3">{store.name}</h5>
      <div className="card border-0 shadow-sm mt-3">
        <div className="card-body d-flex justify-content-between">
          <div style={{ maxWidth: "65%" }}>
            <small className="text-muted">Alamat Toko</small>
            <p className="fw-semibold mb-0">{store.address}</p>
            {store.landmark && (
              <small className="text-muted fst-italic">
                *{store.landmark}
              </small>
            )}
          </div>

          {/* <img
            src="/mini-map.jpg"
            alt="map"
            className="rounded"
            style={{ width: 120, height: 120, objectFit: "cover" }}
          /> */}
        </div>
      </div>

      <div className="card border-0 shadow-sm mt-3">
        <div className="card-body">
          <small className="text-muted">POSM Diizinkan</small>

          <ul className="list-unstyled mt-2">
            {store.posmAllowed.map((item: any) => (
              <li key={item.id} className="d-flex align-items-center mb-2">
                <div className="posm-dot bg-ps-primary me-2"></div>
                <span className="fw-semibold">{item.name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="card border-0 shadow-sm mt-3">
        <div className="card-body">
          <small className="text-muted">Foto</small>

          <div className="d-flex gap-2 mt-2 flex-wrap">
            <button
              className={`btn btn-sm ${filter === "all"
                  ? "btn-primary"
                  : "btn-outline-secondary"
                }`}
              onClick={() => setFilter("all")}
            >
              All
            </button>

            {galleryGroups.map((group: any) => (
              <button
                key={group.id}
                className={`btn btn-sm ${filter === group.id
                    ? "btn-primary"
                    : "btn-outline-secondary"
                  }`}
                onClick={() => setFilter(group.id)}
              >
                {group.name}
              </button>
            ))}
          </div>

          <div className="row mt-3">
            {filteredPhotos.map((photo: any) => (
              <div className="col-6 mb-3" key={photo.id}>
                <img
                  src={photo.url}
                  alt="photo toko"
                  className="rounded"
                  style={{
                    width: "100%",
                    height: 130,
                    objectFit: "cover",
                  }}
                />
              </div>
            ))}

            {filteredPhotos.length === 0 && (
              <div className="text-muted text-center mt-3">
                Tidak ada foto
              </div>
            )}
          </div>
        </div>
      </div>

      {/* <button
        className="btn btn-primary rounded-circle shadow-lg"
        style={{
          position: "fixed",
          bottom: 85,
          right: 22,
          width: 55,
          height: 55,
          fontSize: 24,
          padding: 0,
        }}
      >
        <i className="fa fa-pencil" style={{ fontSize: 24 }}></i>
      </button> */}
    </div>
  );
};

export default ManageStoreDetailPage;